var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7204 21.1265C17.6391 22.8844 14.9392 24 12 24C7.62661 24 3.7875 21.5906 1.7063 18.075L2.48545 14.4833L5.93911 13.8422C6.74067 16.4296 9.15938 18.3281 12 18.3281C13.3781 18.3281 14.6579 17.8922 15.7125 17.1187L19.0313 17.625L19.7204 21.1265Z",
    fill: "#59C36A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7203 21.1266L19.0313 17.625L15.7125 17.1188C14.6578 17.8922 13.3781 18.3281 12 18.3281V24C14.9391 24 17.6391 22.8844 19.7203 21.1266Z",
    fill: "#00A66C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67187 12.0001C5.67187 12.6469 5.77031 13.2656 5.93906 13.8422L1.70625 18.0751C0.651563 16.3032 0 14.2219 0 12.0001C0 9.77813 0.651563 7.69692 1.70625 5.92505L5.10342 6.50972L5.93906 10.1579C5.77031 10.7344 5.67187 11.3531 5.67187 12.0001Z",
    fill: "#FFDA2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 15.6562 22.3079 18.9328 19.7203 21.1266L15.7125 17.1188C16.5281 16.5281 17.2172 15.7406 17.6672 14.8125H12C11.6062 14.8125 11.2969 14.5031 11.2969 14.1094V9.89063C11.2969 9.49683 11.6062 9.1875 12 9.1875H23.1C23.4375 9.1875 23.7328 9.42652 23.7891 9.76402C23.9297 10.4953 24 11.2546 24 12Z",
    fill: "#4086F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6672 14.8125C17.2172 15.7406 16.5281 16.5281 15.7125 17.1188L19.7203 21.1266C22.3079 18.9328 24 15.6563 24 12C24 11.2546 23.9297 10.4953 23.789 9.76402C23.7328 9.42652 23.4375 9.1875 23.1 9.1875H12V14.8125H17.6672Z",
    fill: "#4175DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9172 3.35152C19.9313 3.54839 19.8469 3.73125 19.7204 3.87183L16.711 6.86714C16.472 7.12027 16.0782 7.14839 15.797 6.93745C14.6859 6.10781 13.3781 5.67188 12 5.67188C9.15938 5.67188 6.74067 7.57027 5.93911 10.1578L1.7063 5.925C3.7875 2.40938 7.62661 0 12 0C14.7985 0 17.5266 1.03125 19.6641 2.8312C19.8188 2.95781 19.9032 3.15464 19.9172 3.35152Z",
    fill: "#FF7F23"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7969 6.93745C16.0781 7.14844 16.4718 7.12027 16.7109 6.86714L19.7203 3.87183C19.8469 3.73125 19.9313 3.54844 19.9172 3.35152C19.903 3.15459 19.8187 2.95781 19.664 2.8312C17.5266 1.03125 14.7984 0 12 0V5.67188C13.3781 5.67188 14.6859 6.10781 15.7969 6.93745Z",
    fill: "#F03800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.16b487ff00e052e9c499e66862a4eb0d.svg";
export { ForwardRef as ReactComponent };